import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { ResponseUtil } from '../../shared/utils/response-util';
import { EventStore } from './event.store';
import { ReservationCompare } from '../models/reservation-compare';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';

@Injectable()
export class ReservationCompareService {

  private eventUrl: string = this.environment.baseUrl + '/api/events';

  constructor(private http: AuthHttp,
              private environment: EnvironmentConfiguration) {
  }

  get(eventId: number): Observable<List<ReservationCompare>> {
    const reservationUrl = `${this.eventUrl}/${eventId}/compare`;

    return this.http.get(reservationUrl)
      .map((res: Response) => List<ReservationCompare>(res.json()))
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/reservation-compare-http-service.ts